export default __webpack_public_path__ + "static/media/porto.89bb44b9.JPG";